import { ChangeDetectionStrategy, Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionPreviewKeyValueSection } from '../../../../../services/gable/gable.service';

/**
 * Generic `key_value` section — a label-over-grid of label/value pairs.
 * Reusable for any action whose preview needs to display "field X: value
 * Y" rows (e.g. a vendor invitation showing email + role + invited-by).
 */
@Component({
    selector: 'app-ap-key-value-section',
    templateUrl: './key-value-section.component.html',
    styleUrls: ['./key-value-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActionPreviewKeyValueSectionComponent {
    @Input({ required: true }) section!: ActionPreviewKeyValueSection;

    trackByIndex(index: number): number {
        return index;
    }
}
